export const contextAliases: Record<string, string[]> = {
  dialog: ["dialog", "modal"],
  tooltip: ["tooltip"],
  menu: ["menu", "dropdown", "kebab", "meatball", "overflow", "popover"],
  disclosure: ["disclosure", "details", "expander"],
  accordion: ["accordion"],
  listbox: ["listbox", "select", "combobox"],
  tablist: ["tablist", "tabs"],
  tree: ["tree", "treeview"],
};
